import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 15.75C10.8639 15.75 12.5514 14.9945 13.773 13.773C14.9945 12.5514 15.75 10.8639 15.75 9C15.75 7.13606 14.9945 5.44855 13.773 4.22703C12.5514 3.00552 10.8639 2.25 9 2.25C7.13606 2.25 5.44855 3.00552 4.22703 4.22703C3.00552 5.44855 2.25 7.13606 2.25 9C2.25 10.8639 3.00552 12.5514 4.22703 13.773C5.44855 14.9945 7.13606 15.75 9 15.75Z",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 9L8.25 11.25L12.75 6.75",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }